// TransactionsTab.tsx
import React from "react";
import { RevenueTransaction, ColorTheme } from "../types/revenue.types";
import { TransactionCard } from "../cards/TransactionCard";

interface TransactionsTabProps {
  transactions: RevenueTransaction[];
  colorTheme: ColorTheme;
}

export const TransactionsTab: React.FC<TransactionsTabProps> = ({
  transactions,
  colorTheme,
}) => {
  return (
    <div>
      <div
        style={{
          background: "white",
          padding: "24px",
          borderRadius: "12px",
          marginBottom: "16px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "16px",
          }}
        >
          <h2
            style={{
              fontSize: "20px",
              fontWeight: "600",
              color: colorTheme.gray900,
            }}
          >
            💰 All Transactions
          </h2>
          <div style={{ fontSize: "14px", color: colorTheme.gray600 }}>
            Total: {transactions.length} transactions
          </div>
        </div>
      </div>

      <div style={{ maxHeight: "calc(100vh - 300px)", overflowY: "auto" }}>
        {transactions.map((transaction) => (
          <TransactionCard
            key={transaction.id}
            transaction={transaction}
            colorTheme={colorTheme}
          />
        ))}
      </div>

      {transactions.length === 0 && (
        <div
          style={{
            textAlign: "center",
            padding: "40px",
            color: colorTheme.gray500,
          }}
        >
          <div style={{ fontSize: "48px", marginBottom: "16px" }}>💰</div>
          <p>No transactions found for the selected period.</p>
        </div>
      )}
    </div>
  );
};
